// extracted by mini-css-extract-plugin
export default {"RemoveNewsFeedModal":"RemoveNewsFeedModal_RemoveNewsFeedModal__c4Mli","Options":"RemoveNewsFeedModal_Options__HjrPi"};